import { FormBuilder, FormGroup } from '@angular/forms';
import { PostalAddress } from '../../../common/model/postal-address';
import { FormComponentBase } from '../../../core/component/forms/form-component.base';
import { FormControlEx } from '../../../core/component/forms/form-control';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { MessageService } from '../../../core/service/message.service';
import { MailStatus } from '../../model/const/enums';
import { Mail } from '../../model/mail';
import { MailService } from '../../service/data/mail.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { ActivatedRoute } from '@angular/router';
import { standardCommand } from '../../../core/model/command';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';

export abstract class LetterFormComponentBase extends FormComponentBase<Mail> {
  constructor(
    activatedRoute: ActivatedRoute,
    protected fb: FormBuilder,
    protected fc: FormControlExFactory,
    protected service: MailService,
    dispatcher: CommandDispatcher,
    handlerResolver: CommandHandlerResolver,
    messageService: MessageService,
    navigation: NavigationService
  ) {
    super(activatedRoute, service, messageService, navigation, dispatcher, handlerResolver);
    this.addMenuItemDefinition('CREATE_BTN', standardCommand.create);
  }

  senderAddress: PostalAddress;
  get canSend(): boolean {
    return this.form && this.form.valid;
  }
  get showSend(): boolean {
    return this.dataContext && this.dataContext.status === MailStatus.Created;
  }

  protected createModel(): Mail {
    return new Mail();
  }

  protected getFormGroup(): FormGroup {
    return this.fb.group({
      body: this.fc.createMandatory('MAIL_FORM.BODY_LABEL', this.dataContext.body),
      footer: this.fc.createMandatory('MAIL_FORM.FOOTER_LABEL', this.dataContext.footer),
      header: this.fc.createMandatory('MAIL_FORM.HEADER_LABEL', this.dataContext.header),
      senderAddress: this.fb.group({}),
    });
  }

  protected init(letter: Mail) {
    super.init(letter);
    if (this.isNew) {
      this.service.getMailDefaults().subscribe(
        defaults => {
          if (defaults) {
            this.senderAddress = defaults.senderAddress;
            this.form.controls['footer'].setValue(defaults.footer);
          }
        },
        error => this.messageService.showError(error)
      );
    } else {
      this.senderAddress = this.dataContext.senderAddress;
    }
  }
}
